/* Package JSON Import will be here */
import { sumBy } from "lodash";
/* Package JSON Import will be here */

/* Project Import will be here */
import { getErrorObject } from "../../utilities/utils";
import { getUnpaidInvoiceListApi, getPaidInvoiceListApi } from "services/payment";
import { getDMSPendingInvoiceListApi, getDMSPaidInvoiceListApi } from "services/dms/dmsPayment";
import { IDmsRequestParams } from "models/dmsPaymentModels";
/* Project Import will be here */

export const types = {
    UNPAID_INVOICE_LIST_REQUEST: "paymentInvoiceList/unpaidInvoiceListRequest",
    UNPAID_INVOICE_LIST_SUCCESS: "paymentInvoiceList/unpaidInvoiceListSuccess",
    UNPAID_INVOICE_LIST_FAILURE: "paymentInvoiceList/unpaidInvoiceListFailure",
    PAID_INVOICE_LIST_REQUEST: "paymentInvoiceList/paidInvoiceListRequest",
    PAID_INVOICE_LIST_SUCCESS: "paymentInvoiceList/paidInvoiceListSuccess",
    PAID_INVOICE_LIST_FAILURE: "paymentInvoiceList/paidInvoiceListFailure"
};

let initialState = {
    unpaidInvoice: {
        isLoading: false,
        totalOsAmount: 0,
        unpaidInvCount: 0,
        data: [],
        error: null
    },
    paidInvoice: {
        isLoading: false,
        data: [],
        error: null
    }
};

export const paymentInvoiceList = (state = initialState, action) => {
    switch (action.type) {
        case types.UNPAID_INVOICE_LIST_REQUEST:
            return {
                ...state,
                unpaidInvoice: {
                    ...state.unpaidInvoice,
                    isLoading: true
                }
            };
        case types.UNPAID_INVOICE_LIST_SUCCESS:
            return {
                ...state,
                unpaidInvoice: {
                    ...action.payload,
                    isLoading: false,
                    error: null
                }
            };
        case types.UNPAID_INVOICE_LIST_FAILURE:
            return {
                ...state,
                unpaidInvoice: {
                    ...state.unpaidInvoice,
                    isLoading: false,
                    error: action.payload.error
                }
            };
        case types.PAID_INVOICE_LIST_REQUEST:
            return {
                ...state,
                paidInvoice: {
                    ...state.paidInvoice,
                    isLoading: true
                }
            };
        case types.PAID_INVOICE_LIST_SUCCESS:
            return {
                ...state,
                paidInvoice: {
                    ...action.payload,
                    isLoading: false,
                    error: null
                }
            };
        case types.PAID_INVOICE_LIST_FAILURE:
            return {
                ...state,
                paidInvoice: {
                    ...state.paidInvoice,
                    isLoading: false,
                    error: action.payload.error
                }
            };
        default:
            return state;
    }
};

/* Get unpaid invoice list to display in the unpaid invoice tab */
export const getUnpaidInvoiceList = () => {
    return async (dispatch, getState) => {
        dispatch({ type: types.UNPAID_INVOICE_LIST_REQUEST });
        try {
            let response = null;
            if (window.dmsServiceApiUrl !== "") {
                /* Handling request params */
                const localStoreObject = getState().localStore.user;
                const requestData: IDmsRequestParams = {
                    RetailerCode: localStoreObject.retailercode,
                    DistributorCode: localStoreObject.distributorcode
                };

                response = await getDMSPendingInvoiceListApi(requestData);

                /* Handling response params */
                let successResponseObject = {
                    UnpaidInvoiceList: response.data,
                    TotalOutstandingAmount: sumBy(response.data, (o) => {
                        return o.OutstandingAmount;
                    }),
                    UnpaidInvoiceCount: response.data.length
                };
                response.data.Data = successResponseObject;
            }
            else {
                response = await getUnpaidInvoiceListApi();
            }

            dispatch({
                type: types.UNPAID_INVOICE_LIST_SUCCESS,
                payload: {
                    totalOsAmount: response.data.Data.TotalOutstandingAmount,
                    unpaidInvCount: response.data.Data.UnpaidInvoiceCount,
                    data: response.data.Data.UnpaidInvoiceList
                }
            });
        }
        catch (error) {
            const { message } = getErrorObject(error);
            dispatch({
                type: types.UNPAID_INVOICE_LIST_FAILURE,
                payload: { error: message }
            });
        }
    }
};

/* Get paid invoice list to display in the paid invoice tab */
export const getPaidInvoiceList = () => {
    return async (dispatch, getState) => {
        dispatch({ type: types.PAID_INVOICE_LIST_REQUEST });
        try {
            let response = null;
            if (window.dmsServiceApiUrl !== "") {
                /* Handling request params */
                const localStoreObject = getState().localStore.user;
                const requestData: IDmsRequestParams = {
                    RetailerCode: localStoreObject.retailercode,
                    DistributorCode: localStoreObject.distributorcode
                };

                response = await getDMSPaidInvoiceListApi(requestData);

                /* Handling response params */
                response.data.Data = response.data;
            }
            else {
                response = await getPaidInvoiceListApi();
            }

            dispatch({
                type: types.PAID_INVOICE_LIST_SUCCESS,
                payload: {
                    data: response.data.Data
                }
            });
        }
        catch (error) {
            const { message } = getErrorObject(error);
            dispatch({
                type: types.PAID_INVOICE_LIST_FAILURE,
                payload: { error: message }
            });
        }
    }
};